<template>
  <button class="m-button" :disabled="loading" @click="$emit('click')">
    <i v-show="loading" class="fa fa-spinner fa-spin" />
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'MButton',
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
  },
}
</script>
